import * as React from 'react';
import Link from '@mui/material/Link'; 
import { useTheme } from '@mui/material/styles';
import {Box, Card, Grid, CardContent, CardMedia, Typography, Button} from '@mui/material';

import tinto from './imagenesPruebas/vinoTinto.png';
import blanco from './imagenesPruebas/vinoBlanco.jpg';
import cartera from './imagenesPruebas/carteraCuero.jpg';
import billetera from './imagenesPruebas/billetera.jpg';
import cena from './imagenesPruebas/cenaRomantica.jpg';
import spa from './imagenesPruebas/diaDeSpa.jpg';
import kayak from './imagenesPruebas/kayak.JPG';
import tirolesa from './imagenesPruebas/tirolesa.jpg';
import cabalgata from './imagenesPruebas/cabalgata.jpg';
import subida from './imagenesPruebas/subida.jpg';
import DialogMoreInfoActivity from '../components/activities/DialogMoreInfoActivity';

function Activities() {
  const theme = useTheme();

  const activitiesList = [
    { 
      activityName: 'Kayak',
      description : 'Descripcion del excelente Cena Romantica que se encuentra a la venta en nuestro motor que ofrece venta de activityos',
      image : kayak,
      price : 150,
      currency : 'USD',
      conditions: 'Aca se pueden agregar todos los terminos y condiciones que tiene dicho activityo para la venta'
    },
    { 
      activityName: 'Tirolesa',
      description : 'Descripcion del excelente Día de Spa que se encuentra a la venta en nuestro motor que ofrece venta de activityos',
      image : tirolesa,
      price : 100,
      currency : 'USD',
      conditions: 'Aca se pueden agregar todos los terminos y condiciones que tiene dicho activityo para la venta'
    },
    { 
      activityName: 'Cabalgata',
      description : 'Descripcion del excelente vino tinto que se encuentra a la venta en nuestro motor que ofrece venta de activityos',
      image : cabalgata,
      price : 50,
      currency : 'USD',
      conditions: 'Aca se pueden agregar todos los terminos y condiciones que tiene dicho activityo para la venta'
    },
    { 
      activityName: 'Subida al cerro',
      description : 'Descripcion del excelente vino blanco que se encuentra a la venta en nuestro motor que ofrece venta de activityos',
      image : subida,
      price : 45,
      currency : 'USD',
      conditions: 'Aca se pueden agregar todos los terminos y condiciones que tiene dicho activityo para la venta'
    },

  ];

  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [selectedActivity, setSelectedActivity] = React.useState(null);

  const handleClickOpen = (activity) => {
    setSelectedActivity(activity);
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  return (
    <div>
      <Grid container spacing={3}>
        { 
          activitiesList.map((activity) => (
            <Grid item xs={12} md={6} key={activity.activityName}>
              <Card>
                <CardMedia
                  component="img"
                  height="200"
                  image={activity.image}
                  alt={activity.activityName}
                />
                <CardContent>
                  <Typography variant="h5" component="div">
                    {activity.activityName}
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary" component="div">
                    {activity.description}  
                  </Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                    <Link href="#" color="#007289" onClick={() => handleClickOpen(activity)}>Más información</Link>
                    <Box sx={{ textAlign: 'right' }}>
                      <Typography variant="h6" component="div">
                        {activity.currency} {activity.price}  
                      </Typography>
                      <Button variant="contained" sx={{ mt: 1 }}>Agregar</Button>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))
        }
      </Grid>
      <DialogMoreInfoActivity open={dialogOpen} handleClose={handleClose} activity={selectedActivity} />
    </div>
  );
}

export default Activities;
